module.exports = " <div class=steps> <div class=\"row small-up-4 text-center\"> <template v-for=\"step in steps\"> <div class=column> <button class=step-link v-link=\"{ name: step.slug, activeClass: 'step-link--is-active'}\" disabled=disabled> <span class=step-number>{{ $index + 1 }}</span> {{ step.title }} </button> </div> </template> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/WizardSteps.vue
// module id = 341
// module chunks = 2